import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
// import CookieConsent from 'react-cookie-consent'; /* temporary banner will be live from April 21 - May 5 at noon */

import { IntlContext } from '../../Providers/Intl';
import Blade from '../Blade';
import { Context } from '../../Providers/Blade';
import SkipToContent from '../SkipToContent';
import PromoLink from '../PromoLink';
import MenuItem from '../MenuItem';

import { MobileNav, DesktopNav, InfoBar } from './layout';
import {
  StyledHeader,
  Wrapper,
  LogoLink,
  Logo,
  Menu,
  Play,
  Overlay,
} from './styles';

export const Header = ({ data, location }) => {
  if (!data) return null;

  // * We keep the state for the header menu contained within contentxt
  const { state, resetState } = useContext(Context);

  // * Destructuring the fields off of data
  const {
    image: logo,
    imageSharp: logoSharp,
    menu,
    loginLink,
    loginText,
    playLink,
    playText,
    infobarShowHide,
    infobarBackgroundColor,
    infobarForegroundColor,
    infobarTextHtml,
    infobarCtaText,
    infobarCtaUrl,
  } = data;

  const [openSections, setOpenSections] = useState({});

  // * We use the double ! because if the label doesnt exist in state it will return undefined, and by using the double ! we can convert the undefined to false
  const onClick = label => {
    const isOpen = !!openSections[label];
    setOpenSections({
      [label]: !isOpen,
    });
  };

  return (
    <>
      <Overlay
        isOpen={Object.values(openSections).includes(true)}
        onClick={() => setOpenSections({})}
      />
      <StyledHeader>
        <SkipToContent />
        {infobarShowHide && (
          <InfoBar
            background={infobarBackgroundColor}
            foreground={infobarForegroundColor}
            textHtml={infobarTextHtml}
            ctaText={infobarCtaText}
            ctaUrl={infobarCtaUrl.url}
          />
        )}
        <Wrapper className="auto-margin">
          <LogoLink
            className="inline"
            to="/"
            name="prodigy"
            ariaLabel="go to Prodigy homepage"
          >
            <Logo src={logoSharp.publicURL} alt={logo.altTag} />
          </LogoLink>
          <DesktopNav
            menu={menu}
            openSections={openSections}
            location={location}
            onClick={onClick}
            loginLink={loginLink}
            loginText={loginText}
            playLink={playLink}
            playText={playText}
            resetState={() => setOpenSections({})}
          />
          <MobileNav loginLink={loginLink} loginText={loginText} location={location} />
        </Wrapper>
        <Blade
          title="test-blade"
          isOpen={state}
          logo={logo}
          logoSharp={logoSharp}
        >
          <>
            {menu && (
              <Menu className="no-bullets">
                {menu.map((info, index) => {
                  return (
                    <li key={`menu-item-${index.toString()}`}>
                      <MenuItem
                        data={info}
                        isOpen={!!openSections[info.text]}
                        label={info.text}
                        onClick={onClick}
                        resetState={() => resetState()}
                      />
                    </li>
                  );
                })}
              </Menu>
            )}
            {
              !(location && location.pathname.includes('/tutoring')) &&
              <PromoLink
              to={loginLink.url}
              className="ghost-on-light-bg"
              ariaLabel={loginLink.ariaLabelLogin}
              queryString={loginLink.queryStringLogin}
            >
              {loginText}
            </PromoLink> 
            }
            { location && location.pathname.includes('/tutoring') ?
              <Play
              to="https://www.prodigygame.com/tutoring/public/identification/"
              ariaLabel={playLink.ariaLabelPlay}
              queryString={playLink.queryStringPlay}
              className="solid-on-light-bg"
              >
                Book free session
              </Play> 
              :
              <Play
                to={playLink.url}
                className="solid-on-light-bg"
                ariaLabel={playLink.ariaLabelPlay}
                queryString={playLink.queryStringPlay}
              >
                {playText}
              </Play>
            }
          </>
        </Blade>
      </StyledHeader>
      {/* temporary banner this will be live from April 21 - May 5 at noon */}
      {/* <CookieConsent
        expires={14}
        style={{
          background: '#a9e7f5',
          color: '#000',
          textAlign: 'center',
          position: 'inherit',
        }}
        buttonStyle={{ background: '#a9e7f5', fontSize: '16px' }}
        buttonText="x"
        hideOnAccept="true"
        location="top"
      >
        Hi! We’ve updated our privacy policy
        <a
          style={{ display: 'inline-flex', marginLeft: '20px' }}
          href="https://https://www.prodigygame.com/main-en/privacy-policy/"
        >
          <div style={{ background: '#FFFFFF', width: 'fit-content' }}>
            <p
              style={{
                color: '#FF5C0B',
                margin: '0 15px',
                fontWeight: '600',
                borderRadius: '4px',
                borderWidth: '3px',
              }}
            >
              Read full policy
            </p>
          </div>
        </a>
      </CookieConsent> */}
    </>
  );
};

Header.propTypes = {
  data: PropTypes.shape().isRequired,
};

Header.defaultProps = {};

const withStaticQueryHeader = ({location}) => {
  return (
    <StaticQuery
      query={graphql`
        query headerQuery {
          prodigy {
            headerFooter {
              header {
                lang
                image {
                  url
                  altTag
                }
                imageSharp {
                  publicURL
                }
                loginText
                loginLink {
                  url
                }
                playText
                playLink {
                  url
                }
                menu {
                  text
                  type
                  url
                  subitems {
                    text
                    type
                    url
                    subitems {
                      text
                      type
                      url
                      linkType
                      queryString
                      ariaLabel
                    }
                    queryString
                    ariaLabel
                  }
                  ariaLabel
                  queryString
                }
                queryStringPlay
                queryStringLogin
                ariaLabelPlay
                ariaLabelLogin
                infobarShowHide
                infobarBackgroundColor
                infobarForegroundColor
                infobarTextHtml
                infobarCtaText
                infobarCtaUrl {
                  url
                }
              }
            }
          }
        }
      `}
      render={({ prodigy }) => {
        const { intl } = useContext(IntlContext);
        const { header } = prodigy.headerFooter.find(
          ({ header: headerData }) =>
            headerData.lang ===
            /* check if lang being defaulted to is x-default (a catchall to default to main-en) */
            (intl.lang === 'x-default' ? 'en-ca' : intl.lang)
        );
        return <Header data={header} location={location} />;
      }}
    />
  );
};

export default withStaticQueryHeader;